<template>
<div id='' class="hostInfo">

    <!-- 服务列表 -->
    <van-popup v-model="showpopup" round position="bottom" style="height: 90%; padding-top: 4px;" @close="handle_close_popup">
        <!-- {{obj}} -->

        <van-divider content-position="left">主机信息</van-divider>
        <div class="hostCard">

            <van-cell-group style="border:1px solid #ebedf0">
                <van-cell>
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                        <span class="custom-title"> {{ alias ?'主机名':'主机ID'}} </span>
                    </template>
                    <template #default>
                        <span class="custom-title custom-title2">
                            {{alias?alias:obj.serverId}}

                            <i class="hostname_status" :class="[status==1?'status_on':'status_off']"></i>

                        </span>

                        
                    </template>

                </van-cell>
                <van-cell>
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                        <span class="custom-title">CPU占用率</span>
                    </template>
                    <template #default>
                        <span class="custom-title">{{ cpu | fil_persen3}}</span>
                    </template>

                </van-cell>
                <van-cell>
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                        <span class="custom-title">CPU占用率</span>
                    </template>
                    <template #default>
                        <span class="custom-title">{{ memory.used  | fil_persen3}}</span>
                    </template>

                </van-cell>
            </van-cell-group>

        </div>

        <van-divider content-position="left">服务监控</van-divider>

        <div class="serveCardList">

            <div class="serveCard" v-for="item in list">
                <!-- 左右结构 -->
                <div class="left">
                    <!--上下结构 服务信息  -->
                    <div class="left_top">
                        {{ item.name }}
                        <div class="status">
                            <span v-if="item.status == 1"> {{ item.status_repeat?'重启中':'运行中' }} <i class="icon_runing"></i></span>
                            <span v-else>已停止 <i class="icon_stop"></i></span>
                        </div>
                    </div>
                    <div class="left_buttom">
                        更新时间：{{ item.time }}
                    </div>

                </div>
                <div class="right">
                    <!--上下结构 服务操作 停止、重启 按钮-->

                    <van-button v-if="item.status == 1" class="btn" size="small" type="warning" @click="handleStop(item)">停止</van-button>
                    <van-button v-if="item.status == 1" class="btn" size="small" type="danger" @click="handleRepeat(item)">重启</van-button>

                    <van-button v-if="item.status == 0" class="btn" size="small" type="info" @click="handleStart(item)">启动</van-button>

                </div>

                <!-- <van-divider /> -->
            </div>

        </div>

    </van-popup>
</div>
</template>

<script>
import {
    getHostServerStatus,
    getHostServerLst,
    startService,
    restartService,
    stopService,

} from './../../api'
export default {
    name: '',

    components: {

    },
    props: {

    },
    data() {
        return {
            obj: '',
            showpopup: false,

            alias:"",
            status:"",

            cpu: "",
            memory: {
                available: "",
                total: "",
                used: ""
            },

            timer1: "",
            timer2: "",

            list: [],
        }
    },
    created: function () {

    },
    beforeDestroy: function () {
        clearTimeout(this.timer1)
        clearTimeout(this.timer2)
    },
    mounted: function () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
        init() {
            let header = {
                "x-access-token": localStorage.getItem('token')
            }
            this.$http.get(`${getHostServerStatus}?serverId=${this.obj.serverId}`, {
                headers: header
            }, ).then(res => {
                console.log(res)
                if (res.data.code == 200) {
                    let obj = res.data.result;
                    // idle 空闲率
                    this.cpu = ((1 - obj.cpu.idle) * 100).toFixed(2)
                    this.alias= obj.alias;
                    this.status = obj.status;

                    this.memory.available = ((obj.memory.available) / (1024 * 1024 * 1024)).toFixed(2)
                    this.memory.total = ((obj.memory.total) / (1024 * 1024 * 1024)).toFixed(2)
                    this.memory.used = (((this.memory.total - this.memory.available) / this.memory.total) * 100).toFixed(2)

                }

            }).catch(err => {
                console.log(err)
            })

            //             this.timer1 = setTimeout(() => {
            // this.init()
            //             }, 1000);

        },
        do_getHostServerLst() {
            let header = {
                "x-access-token": localStorage.getItem('token')
            }
            this.$http.get(`${getHostServerLst}?serverId=${this.obj.serverId}`, {
                headers: header
            }, ).then(res => {
                console.log(res)
                if (res.data.code == 200) {
                    let list = [];
                    res.data.result.map(item => {
                        // id: "1848247748968615939"
                        // msg: "启动成功"
                        // name: "myapp"
                        // runTime: "2024-10-22 13:56:18"
                        // status: 1
                        list.push({
                            id: item.winService.id, // 服务id
                            name: item.winService.name, // 服务名
                            desc: item.winService.msg, // 服务情况
                            status: item.winService.status, //状态  1 运行中  0 已停止
                            time: item.winService.runTime,

                            status_stop: false,
                            status_repeat: false,
                            status_strat: false,
                        })
                    })
                    this.list = [...list]
                }
            }).catch(err => {
                console.log(err)
            })

            //             this.timer2 = setTimeout(() => {
            // this.do_getHostServerLst()
            //             }, 1000);

        },
        handle_show_popup(obj) {
            this.obj = obj
            this.showpopup = true;
            this.init();
            this.do_getHostServerLst()
        },
        handle_close_popup() {
            this.showpopup = false;

            clearTimeout(this.timer1)
            clearTimeout(this.timer2)
        },

        handleStop(obj) {
            clearTimeout(this.timer1)
            clearTimeout(this.timer2)
            let header = {
                "x-access-token": localStorage.getItem('token')
            }
            if (obj.status_stop) {
                this.$toast('正在停止中，请稍后');
                return
            }
            obj.status_stop = true;
            // serverId  /  name

            this.$http.get(`${stopService}?serverId=${this.obj.serverId}&name=${obj.name}`, {
                headers: header
            })
            .then(res => {
                console.log(res)
                obj.status_stop = false;
                if (res.data.code == 200) {
                    this.$toast('停止操作成功')
                    
                    this.init();
            this.do_getHostServerLst()
                }
            }).catch(err => {
                obj.status_stop = false;

                this.init();
            this.do_getHostServerLst()
            })

        },
        handleStart(obj) {

            console.log(obj)
            clearTimeout(this.timer1)
            clearTimeout(this.timer2)
            let header = {
                "x-access-token": localStorage.getItem('token')
            }

            console.log(obj)
            if (obj.status_strat) {
                this.$toast('正在启动中，请稍后');
                return
            }
            obj.status_strat = true;
            this.$http.get(`${startService}?serverId=${this.obj.serverId}&name=${obj.name}`, {
                headers: header
            }).then(res => {
                console.log(res)
                obj.status_strat = false;
                if (res.data.code == 200) {
                    this.$toast('启动操作成功')
                    
                    this.init();
            this.do_getHostServerLst()


                }
            }).catch(err => {
                obj.status_strat = false;

                this.init();
            this.do_getHostServerLst()
            })
        },
        handleRepeat(obj) {
            clearTimeout(this.timer1)
            clearTimeout(this.timer2)
            let header = {
                "x-access-token": localStorage.getItem('token')
            }

            if (obj.status_repeat) {
                this.$toast('正在重启中，请稍后');
                return
            }
            obj.status_repeat = true;

            this.$http.get(`${restartService}?serverId=${this.obj.serverId}&name=${obj.name}`, {
                headers: header
            }).then(res => {
                console.log(res)
                obj.status_repeat = false;
                if (res.data.code == 200) {
                    this.$toast('重启成功')
                    
                    this.init();
            this.do_getHostServerLst()
                }
            }).catch(err => {
                obj.status_repeat = false;

                this.init();
            this.do_getHostServerLst()
            })

        }
    },
}
</script>

<style lang="less">
.hostInfo {
    .hostCard {
        margin: auto;
        width: 88vw;

        .van-cell {
            .van-cell__title {
                width: 30%;
                flex: none;
                text-align: left;
            }

            .van-cell__value {}
        }
    }

    .serveCardList {

        .serveCard {
            width: 88vw;
            height: 50px;
            margin: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 6px;
            margin-bottom: 6px;
            border-bottom: 1px solid #e5e5e5;

            .left {
                height: 100%;
                flex: 1;

                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: flex-start;

                .left_top {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 14px;

                    .status {
                        display: flex;
                        font-size: 12px;
                        justify-content: center;
                        align-items: center;

                        .icon_runing {
                            background-color: #52c41a;
                            display: inline-block;
                            width: 5px;
                            height: 5px;
                            border: none;
                            border-radius: 50%;
                            margin-bottom: 3px;
                        }

                        .icon_stop {
                            background-color: #f5222d;
                            display: inline-block;
                            width: 5px;
                            height: 5px;
                            border: none;
                            border-radius: 50%;
                            margin-bottom: 3px;
                        }

                    }
                }

                .left_buttom {
                    width: 100%;
                    display: flex;
                    font-size: 14px;
                    font-weight: 400;
                    color: #666;
                }
            }

            .right {
                height: 100%;
                width: 25%;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: flex-end;

                .btn {
                    width: 80%;
                    height: 24px;
                    font-size: 14px;
                }

            }
        }
    }
}

.hostname_status{
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 3px;
    background-color: #fff;
    margin-left: 6px;
    &.status_on{
        background-color: #52c41a;
    }
    &.status_off{
        background-color: #f5222d;
    }
}
.custom-title2{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>
